import React from 'react';
import classNames from 'classnames';

interface DateFormatterProps {
  departureDate?: Date | string;
  returnDate?: Date | string;
  shipmentDate: Date | string;
  className?: string;
}

const formatDate = (dateString?: Date | string | null): string => {
  if (!dateString) return '-';

  try {
    const date = new Date(dateString);

    if (isNaN(date.getTime())) return '-';

    const mm = String(date.getUTCMonth() + 1).padStart(2, '0');
    const dd = String(date.getUTCDate()).padStart(2, '0');
    const yyyy = date.getUTCFullYear();
    const hours = date.getUTCHours();
    const minutes = String(date.getUTCMinutes()).padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';
    const formattedHours = hours % 12 || 12;

    return `${mm}/${dd}/${yyyy} at ${String(formattedHours).padStart(
      2,
      '0'
    )}:${minutes} ${ampm}`;
  } catch (error) {
    return '-';
  }
};

const DateFormatter: React.FC<DateFormatterProps> = ({
  departureDate,
  returnDate,
  shipmentDate,
  className
}) => {
  return (
    <>
      {departureDate && (
        <div className="d-flex align-items-center mt-4">
          <p className={classNames('mb-0 fw-bold fs-9', className)}>
            Expected Operator Departure:
            <span
              className={classNames('fw-semi-bold ms-1', {
                'text-600': !className,
                'text-white': className
              })}
            >
              {formatDate(departureDate as string)}
            </span>
          </p>
        </div>
      )}
      <div className="d-flex align-items-center mt-1">
        <p className={classNames('mb-0 fw-bold fs-9', className)}>
          Expected Equipment Ship:
          <span
            className={classNames('fw-semi-bold ms-1', {
              'text-600': !className,
              'text-white': className
            })}
          >
            {formatDate(shipmentDate)}
          </span>
        </p>
      </div>
      {returnDate && (
        <div className="d-flex align-items-center mt-1">
          <p className={classNames('mb-0 fw-bold fs-9', className)}>
            Expected Operator Return:{' '}
            <span
              className={classNames('fw-semi-bold ms-1', {
                'text-600': !className,
                'text-white': className
              })}
            >
              {formatDate(returnDate as string)}
            </span>
          </p>
        </div>
      )}
    </>
  );
};

export default DateFormatter;
